// extracted by mini-css-extract-plugin
export default {"switch":"style_switch__r9g4A","slider":"style_slider__6c0Ll","active":"style_active__DyGBy","round":"style_round__l5CkY"};